import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { useState } from "react";
import { Radio, Label } from "theme-ui";
import { SwatchIcon } from "../ColorSwatch";
export const ColorRadio = ({ radioButtonName = "color-radio", colorName, colorHex, onSelect = () => { }, style = {}, inStock = true, checked = false, swatchSize = 20 }) => {
    const [labelClicked, setLabelClicked] = useState(false);
    return (_jsxs(Label, { sx: Object.assign(Object.assign({}, style), { height: `${swatchSize}px`, width: `${swatchSize}px`, cursor: "pointer", "& > div > svg, input:checked ~ svg": {
                display: "none"
            }, ":focus-within": {
                outlineStyle: labelClicked ? "none" : "solid",
                outlineWidth: 2
            } }), onClick: () => setLabelClicked(true), onBlur: () => setLabelClicked(false), children: [_jsx(Radio, { "aria-label": colorName, name: radioButtonName, disabled: !inStock, defaultChecked: checked, onClick: onSelect }), _jsx(SwatchIcon, { color: colorHex, size: swatchSize, selected: checked, inStock: inStock })] }));
};
//# sourceMappingURL=ColorRadio.js.map